module.exports = "https://cdn01.riselinkedu.com/assets/images/report_active.6bdc17f.png";